import urls from '@/utils/urls'
import http from './http'

const config = { baseURL: urls.SSESSMENTS_INSIGHTS_API }

export default {
  getFeatureToggle: (toggleName) => http.get(`toggle/${toggleName}`, config),
}
